import { UserAreaBoundary } from "@/components/UserAreaBoundary";
import { Page } from "@/components/layout/Page";
import { WidgetFrame } from "@/components/layout/WidgetFrame";
import { RepeatVisitCasesKPIWidget } from "@/components/widgets/kpi/RepeatVisitCasesKPIWidget";
import { DateRangeWidget } from "@/components/widgets/selects/DateRangeWidget";
import { colSpan, height } from "@/components/widgets/widget.utils";
import { usePagesState } from "@/hooks/usePagesState";
import { InsightsWidget } from "@/pages/DashboardPage/tss/widgets/InsightsWidget";
import { ServiceHistoryWidget } from "@/pages/DashboardPage/tss/widgets/ServiceHistoryTechnicianWidget";
import { AbnormalPMTimesKPIWidget } from "@/pages/DashboardPage/tss/widgets/kpi/AbnormalPMTimesKPIWidget";
import { ManHoursHighKPIWidget } from "@/pages/DashboardPage/tss/widgets/kpi/ManHoursHighKPIWidget";
import { PMsOverdueKPIWidget } from "@/pages/DashboardPage/tss/widgets/kpi/PMsOverdueKPIWidget";
import { ProductiveHoursKPIWidget } from "@/pages/DashboardPage/tss/widgets/kpi/ProductiveHoursKPIWidget";
import { RepairsPerAstronautKPIWidget } from "@/pages/DashboardPage/tss/widgets/kpi/RepairsPerAstronautKPIWidget";
import { CriticalAlarmsPerAstronautPast12MonthsKPIWidget } from "@/pages/DashboardPage/widgets/kpi/CriticalAlarmsPerAstronautPast12MonthsKPIWidget";
import { SoftwareVersionStatusKpiWidget } from "@/pages/SoftwareVersionOverviewPage/widgets/SoftwareVersionStatusKPIWidget";

export function TSSSubpage() {
    const [dateFrom, setDateFrom] = usePagesState("dateFrom");
    const [dateTo, setDateTo] = usePagesState("dateTo");

    const queryParameters = { dateFrom, dateTo };

    return (
        <>
            <Page.StickyHeader>
                <Page.Header.Widgets>
                    <Page.Header.WidgetFrame colSpan={{ md: 12 }}>
                        <DateRangeWidget
                            onDateToChange={(value) => setDateTo(value)}
                            onDateFromChange={(value) => setDateFrom(value)}
                            dateTo={dateTo}
                            dateFrom={dateFrom}
                        />
                    </Page.Header.WidgetFrame>
                </Page.Header.Widgets>
            </Page.StickyHeader>
            <Page>
                <Page.Header>
                    <Page.Header.Widgets>
                        <Page.Header.WidgetFrame colSpan={{ md: 9 }}>
                            <Page.Header.Title value={"Dashboard"} />
                        </Page.Header.WidgetFrame>
                        <Page.Header.WidgetFrame>
                            <DateRangeWidget
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                onDateFromChange={setDateFrom}
                                onDateToChange={setDateTo}
                            />
                        </Page.Header.WidgetFrame>
                    </Page.Header.Widgets>
                </Page.Header>
                <Page.Content>
                    <Page.Content.Widgets>
                        <UserAreaBoundary areas={["TSS_TeamLead_Core"]}>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <PMsOverdueKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <RepeatVisitCasesKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <RepairsPerAstronautKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <AbnormalPMTimesKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <ManHoursHighKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpi} height={height.kpi}>
                                <ProductiveHoursKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpiHalf} height={height.kpi}>
                                <CriticalAlarmsPerAstronautPast12MonthsKPIWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                            <WidgetFrame colSpan={colSpan.kpiHalf} height={height.kpi}>
                                <SoftwareVersionStatusKpiWidget queryParameters={queryParameters} showLink={true} />
                            </WidgetFrame>
                        </UserAreaBoundary>
                        <WidgetFrame colSpan={colSpan.tableFull}>
                            <InsightsWidget queryParameters={{}} />
                        </WidgetFrame>
                        <UserAreaBoundary areas={["TSS_Technician_Core"]}>
                            <WidgetFrame colSpan={colSpan.tableFull}>
                                <ServiceHistoryWidget queryParameters={queryParameters} />
                            </WidgetFrame>
                        </UserAreaBoundary>
                    </Page.Content.Widgets>
                </Page.Content>
            </Page>
        </>
    );
}
